import axios from "axios";
import {
    URLAPI,
    SHOPPING_CART_PATH,
    SHOPPING_CART_CREATE_PATH,
    SHOPPING_CART_UPDATE_PATH,
    ITEM_SHOPPING_CART_DELETE_PATH,
} from "../config";
import {LOGOUT} from './users'

const init = {
    _get_all_shopping_cart: {
        data: [],
        status: 0,
        message: {},
    },
    _create_shopping_cart: {
        data: {},
        status: 0,
        message: {},
    },
    _update_shopping_cart: {
        data: {},
        status: 0,
        message: {},
    },
    _delete_item_shopping_cart: {
        data: {},
        status: 0,
        message: {},
    },
}

const GET_ALL_SHOPPING_CART_SUCCESS = "GET_ALL_SHOPPING_CART_SUCCESS";
export const CREATE_SHOPPING_CART_SUCCESS = "CREATE_SHOPPING_CART_SUCCESS";
export const UPDATE_SHOPPING_CART_SUCCESS = "UPDATE_SHOPPING_CART_SUCCESS";
export const DELETE_ITEM_SHOPPING_CART_SUCCESS = "DELETE_ITEM_SHOPPING_CART_SUCCESS";

export const shopping_cart_module = (state = init, action) => {
    switch (action.type) {
        case GET_ALL_SHOPPING_CART_SUCCESS:
            return {
                ...state,
                _get_all_shopping_cart: action.payload,
            };
        case CREATE_SHOPPING_CART_SUCCESS:
            return {
                ...state,
                _create_shopping_cart: action.payload,
            };
        case UPDATE_SHOPPING_CART_SUCCESS:
            return {
                ...state,
                _update_shopping_cart: action.payload,
            };
        case DELETE_ITEM_SHOPPING_CART_SUCCESS:
            return {
                ...state,
                _delete_item_shopping_cart: action.payload,
            };
        case LOGOUT:
            return init;
        default:
            return state;
    }
}

export const get_all_shopping_cart = (token) => async (dispatch) => {
    try {
        const response = await axios.get(`${URLAPI}${SHOPPING_CART_PATH}`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: GET_ALL_SHOPPING_CART_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: GET_ALL_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.message,
                },
            });
        } else {
            dispatch({
                type: GET_ALL_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Ocurrió un error",
                },
            });
        }
    }
}

export const create_shopping_cart = (token, data) => async (dispatch) => {
    try {
        console.log(data);

        const response = await axios.post(`${URLAPI}${SHOPPING_CART_CREATE_PATH}`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: CREATE_SHOPPING_CART_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response != null) {
            dispatch({
                type: CREATE_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: CREATE_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: "Error al crear",
                },
            });
        }
    }
}


export const update_shopping_cart = (token, id, data) => async (dispatch) => {
    try {
        const response = await axios.patch(`${URLAPI}${SHOPPING_CART_UPDATE_PATH}${id}/`, data, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: UPDATE_SHOPPING_CART_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: UPDATE_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: UPDATE_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}

export const delete_item_shopping_cart = (token, id) => async (dispatch) => {
    try {
        const response = await axios.delete(`${URLAPI}${ITEM_SHOPPING_CART_DELETE_PATH}${id}/`, {
            headers: {
                Authorization: `Basic ${token}`,
            },
        });
        dispatch({
            type: DELETE_ITEM_SHOPPING_CART_SUCCESS,
            payload: {
                data: response.data,
                status: response.status,
                message: "",
            },
        });
    } catch (error) {
        if (error.response.data != null) {
            dispatch({
                type: DELETE_ITEM_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: error.response.status,
                    message: error.response.data.mensaje,
                },
            });
        } else {
            dispatch({
                type: DELETE_ITEM_SHOPPING_CART_SUCCESS,
                payload: {
                    data: {},
                    status: 500,
                    message: error.message,
                },
            });
        }
    }
}


export const clear_status_shopping_cart = (type) => async dispatch => {
    dispatch({
        type: type,
        payload: {
            data: {},
            status: 0,
            message: {},
        },
    });
}
